import React from 'react';
import '../styles/SesMissions.css';
import '../styles/Root.css';
import assodynamiqueImage from '../assets/sesmissions/assodynamique.jpg';
import rayonnementImage from '../assets/sesmissions/rayonnement.JPG';
import ag2023Image from '../assets/sesmissions/ag2023.JPG';
import videoMusee from '../assets/videosmusee/aamtdm.mp4';

const DEVENIR_ADHERENT_LINK = "/pages/DevenirAdherent";

const SesMissions = () => {
  return (
    <main>
      <section className="hero fade-in">
        <h1>Les Amis du musée</h1>
        <p>Découvrez les missions des Amis du musée des Troupes de Marine</p>
      </section>

      <section className="content-section fade-in">
        <h2>Introduction</h2>
        <p>
          Créée en 1979, les Amis du Musée des Troupes de marine est une association qui apporte son concours à
          l’enrichissement, à la conservation, à la mise en valeur et au rayonnement du patrimoine culturel et
          artistique constitué par les collections du musée, lesquelles témoignent de l’engagement et des vertus
          militaires dont les Troupes de la Marine avant 1900 puis les troupes coloniales de 1900 à 1958 et enfin les
          Troupes de marine ont fait preuve au service de la France.
        </p>
      </section>

      <section className="video-container fade-in">
        <figure>
          <video className="video-border" controls>
            <source src={videoMusee} type="video/mp4" />
            Votre navigateur ne supporte pas la lecture de vidéos.
          </video>
          <figcaption className="video-caption">
            Le Colonel (H) Dutartre, Président des Amis du Musée des Troupes de Marine, présente les missions de l'association.
          </figcaption>
        </figure>
      </section>

      <section className="mission-section fade-in">
        <h2>Une association dynamique</h2>
        <p>
          Le dynamisme de l’association résulte de l’engagement désintéressé des membres bénévoles de son
          conseil d’administration, de ses quelques 9 000 adhérents, d’un budget (cotisations, dons, legs et
          subventions) et de la volonté de faire aboutir ses projets.
        </p>
        <p>
          Hormis ses frais de fonctionnement, l’AAMTDM consacre la totalité de ses ressources au musée qu’elle
          supporte financièrement.
        </p>
        <p>
          Depuis 1979, elle aura contribué pour une très large part à la réalisation du musée et du CHETOM, le
          Centre d’Histoire et d’Etudes des Troupes d’Outre-mer, ainsi qu’à l’achat de très nombreux objets.
        </p>
        <img src={assodynamiqueImage} alt="Assemblée Générale 2023" />
        <a href={DEVENIR_ADHERENT_LINK} className="btn btn-primary">Devenir Adhérent</a>
      </section>

      <section className="mission-section-alt fade-in">
        <h2>Rayonnement</h2>
        <p>
          L’association contribue au rayonnement du musée en soutenant moralement et financièrement le
          Conservateur dans le cadre de ses actions culturelles et éducatives : expositions temporaires, journées
          d’études, festival du court-métrage, printemps des poètes, nuit des musées, journées européennes du
          patrimoine, accueil des scolaires et des soldats.
        </p>
        <p>
          L’association organise un cycle annuel de huit conférences dont les sujets portent sur l’Histoire des
          Troupes de marine, l’histoire militaire, la géopolitique, la géographie physique et humaine de l’Outre-
          mer, les actions d’aides aux populations
        </p>
        <img src={rayonnementImage} alt="Les Amis du Musée au Rétro Auto Forum" />
        <a href={DEVENIR_ADHERENT_LINK} className="btn btn-primary">Devenir Adhérent</a>
      </section>

      <section className="mission-section-dark fade-in">
        <h2>Engagement Communautaire</h2>
        <p>
          Nous sommes engagés dans la vie associative du Territoire, Estérel Côte-d’Azur agglomération, du
          département du Var et de la Région Sud à travers différents partenariats formalisés ou non.
        </p>
        <p>
          Nous participons naturellement au devoir de mémoire en renforçant autant que de besoin l’équipe du
          musée pour accueillir et guider les groupes, notamment scolaires pour qui nous pouvons promouvoir les
          valeurs Républicaines et celles du Soldat (visites guidées, activités éducatives).
        </p>
        <p>
          Nous croyons dans notre rôle d’éducateur et de passeur de mémoire afin de participer au renforcement du
          sentiment patriotique.
        </p>
        <img src={ag2023Image} alt="Engagement Communautaire" />
        <a href={DEVENIR_ADHERENT_LINK} className="btn btn-primary" style={{ border: 'solid 2px white' }}>Devenir Adhérent</a>
      </section>

      <section className="mission-section fade-in">
        <h2>Rejoignez-nous !</h2>
        <p>En devenant adhérent des Amis du Musée des Troupes de Marine, vous contribuez activement à la préservation et à la valorisation de notre patrimoine.</p>
        <p>Votre soutien est essentiel pour nous permettre de remplir nos missions et promouvoir l'histoire des Troupes de Marine.</p>
        <a href={DEVENIR_ADHERENT_LINK} className="btn btn-primary" style={{ border: 'solid 2px white' }}>Devenir Adhérent</a>
      </section>
    </main>
  );
};

export default SesMissions;
